<template>
    <div class="login-pos">
        <img class="login-pos__logo" src="@/assets/images/header/logo.png"/>
        <div class="login-pos__input-password">
            <b-form-input
                    type="text"
                    v-model="scanInput"
                    placeholder="Scan Or Enter value"
                    class="text-center"
                    autofocus="autofocus"
            />
        </div>
        <div class="login-pos__button-login">
          <b-button class="btn-ticket mr-2 btn-back-home" @click="handleBackHome">Back Home</b-button>
          <b-button @click="handleSearch">Search</b-button>
        </div>
    </div>
</template>
<script>
    import lottoService from '@/services/lotto.service';
    import { singleTicket } from '@/resources/loto'
    export default {
        data() {
            return {
                singleTicket: [],
                scanInput: '',
                autofocus: true
            }
        },
        methods: {
            handleBackHome() {
                this.$router.push('/ticket');
            },
            handleSearch() {
                lottoService.checkScanInput(this.scanInput).then((res) => {
                    if (res.status === 'success') {
                        const type = res.data.type;
                        if (type === 'qrCode') {
                            lottoService.scanQrCode(this.scanInput).then((res) => {
                                    if (res.status === 'success') {
                                        const bet = res.data.qr.bets.bet;
                                        if (!this.singleTicket || this.singleTicket.length === 0) {
                                            const newTicket = lottoService.generateTickets(8);
                                            this.singleTicket = [...newTicket];
                                        }
                                        bet.forEach((item, i) => {
                                            const main = item;
                                            this.singleTicket.forEach((ticket, index) => {
                                                if (index === i) {
                                                    ticket.forEach(ticket => ticket.active = main.includes(ticket.number) ? true : false)
                                                }
                                            }) ;
                                        });
                                        this.$store.dispatch('addOrUpdateTickets', this.singleTicket);
                                        this.$router.push('/lotto');

                                    } else {
                                        const message = res.message;
                                        this.$bvToast.toast(message, {
                                            title: 'Failed',
                                            variant: 'danger',
                                            solid: true,
                                            autoHideDelay: 5000
                                        })
                                    }

                                },
                                () => this.$bvToast.toast('Scan QR CODE failed! Please try again', {
                                    title: 'Failed',
                                    variant: 'danger',
                                    solid: true,
                                    autoHideDelay: 5000
                                }));
                        } else if (type === 'transaction') {
                            this.transactions = res.data.transactions;
                            this.$router.push({name: 'TransactionResult', query: {ref: this.scanInput} });
                        }

                    } else {
                        const message = res.message;
                        this.$bvToast.toast(message, {
                            title: 'Failed',
                            variant: 'danger',
                            solid: true,
                            autoHideDelay: 5000
                        })
                    }
                },
                () => this.$bvToast.toast('Scan Ticket failed! Please try again', {
                    title: 'Failed',
                    variant: 'danger',
                    solid: true,
                    autoHideDelay: 5000
                }));
            }
        }
    }
</script>
